import { render, staticRenderFns } from "./UnrealSelfRoom.vue?vue&type=template&id=24ed78c8&"
import script from "./UnrealSelfRoom.vue?vue&type=script&lang=js&"
export * from "./UnrealSelfRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports